export default __webpack_public_path__ + "static/media/Group2265.4f975f01.svg";